// src/app.js

import React, { useLayoutEffect, useState, Fragment, createContext } from 'react';
import { Route, Switch, BrowserRouter, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { NavBar, Footer, FooterNew, FooterGuest, Loading, NavBarNotary, ProfNavBar } from './components';
import { Home, Profile, ExternalApi, AboutUs, Admin, Originator, Notary, Preview, ProfileDetails, SignUp, Support, Escrow, Autos, DataPolicyPage, TitleLandingPage, MessageReply, NotaryOrderView, OriginatorOrderView, AdminOrderView} from './views';
import ProtectedRoute from './auth/protected-route';

import './app.css';
export const UserContext = createContext()

const App = () => {
  const { isLoading } = useAuth0();
  const [isAdmin, setIsAdmin] = useState(false)
  const [isNotary, setIsNotary] = useState(true)
  const [isTitle, setIsTitle] = useState(false)
  const { isAuthenticated } = useAuth0();
  const location = useLocation();
  // The magic-link reply page is reached without a session, but it's only for
  // escrow/notary recipients — show the minimized authorized footer, not the public one.
  const useAuthorizedFooter = isAuthenticated || location.pathname.startsWith('/message-reply')
  const [profileLoaded, setProfileLoaded] = useState(false)
  const [profileDetails, setProfileDetails] = useState([])
  const [userProfile, setUser] = useState([])
  
  
  const myProps = 'hey there'

  const setProfileStatus = (val) => {
    setProfileDetails(val)
    //setUser(val[0])
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
    <UserContext.Provider value={{ userProfile, setUser }}>
    {isAuthenticated && (
      <div>
        <Fragment>
          <ProfNavBar profileEmail={'something@j.com'} func={setProfileStatus}/>
        </Fragment>
      </div>
    )}
    <div id="app" className="d-flex flex-column h-100">
      <NavBar/>
      <div className="container flex-grow-1">
        <Switch>
          <Route path="/" exact component={Home} />
          {/* Order deep-link routes — must precede the broader /notary, /originator,
              /admin routes below (those are not `exact`, so they'd match first). */}
          <ProtectedRoute path="/notary/orders/:orderId" component={NotaryOrderView} />
          <ProtectedRoute path="/originator/orders/:orderId" component={OriginatorOrderView} />
          <ProtectedRoute path="/admin/orders/:orderId" component={AdminOrderView} />
          <ProtectedRoute path="/profile" component={Profile} />
          <ProtectedRoute path="/originator" component={Originator} />
          <ProtectedRoute path="/notary" component={Notary} />
          <ProtectedRoute path="/admin" component={Admin} />
          <ProtectedRoute path="/external-api" component={ExternalApi} />
          <Route path="/about-us" exact component={AboutUs} />
          <Route path="/escrow" exact component={Escrow} />
          <Route path="/sign-up" exact component={SignUp} />
          <Route path="/message-reply/:token" exact component={MessageReply} />
          <Route path="/preview/:id" exact component={Preview} />
          <Route path="/support" exact component={Support} />
          <Route path="/data-policy" exact component={DataPolicyPage} />
          <Route path="/title-landing" exact component={TitleLandingPage} />
          <ProtectedRoute path="/profile-details" component={ProfileDetails} />
        </Switch>
      </div>
      {useAuthorizedFooter ? <FooterNew /> : <FooterGuest />}
    </div>
    </UserContext.Provider>
    </div>
  );
};

export default App;
